import View from './View.js';

import icons from 'url:../../img/icons.svg'; //icons

class PaginationView extends View{
    _parentElement = document.querySelector('.pagination');

    addHandlerClick(handler){
        this._parentElement.addEventListener('click', function(e){
            const btn = e.target.closest('.btn--inline');
            if(!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }

    _generateMarkup(){
        const curPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);

        // Page 1 having other pages
        if(curPage === 1 && numPages > 1){
            return this._addMarkupNext(curPage);
        }

        // Page 1 NOT having other pages
        if(curPage === 1 && numPages === 1){
            return ``;
        }
        
        // Last Page
        if(curPage === numPages){
            return this._addMarkupPrev(curPage);
        }
        
        // other Page
        return this._addMarkupPrev(curPage) + this._addMarkupNext(curPage);
    }

    _addMarkupNext(curPage){
        return `
            <button data-goto="${curPage + 1}" class="btn--inline pagination__btn--next">
                <span>${curPage + 1}</span>
                <svg class="search__icon">
                    <use href="${icons}#icon-arrow-right"></use>
                </svg>
            </button>
        `;
    }

    _addMarkupPrev(curPage){
        if(curPage <= 1) return '';
        return `
            <button data-goto="${curPage - 1}" class="btn--inline pagination__btn--prev">
                    <svg class="search__icon">
                        <use href="${icons}#icon-arrow-left"></use>
                    </svg>
                    <span>${curPage - 1}</span>
            </button>
        `;
    }
};

export default new PaginationView();
